import { render, staticRenderFns } from "./EditDataModal.vue?vue&type=template&id=2b02651c"
import script from "./EditDataModal.vue?vue&type=script&lang=js"
export * from "./EditDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports